import cx from 'classnames'
import { MdDragIndicator } from 'react-icons/md'

import { domains } from '../../../igao/utils'
import { Divider } from '../../../shared/Divider'
import { sing } from '../utils'

import StaticItemEdit from './edit/static-item'
import styles from './items.module.scss'

const OtherItem = ({
  question,
  provided,
  setEditable,
  itemStyles,
  editableQuestion,
  setModal,
  applyChanges,
  setEditableQuestion,
  items,
  actionIcon
}) => {
  const positionDiff =
    question.diff?.index?.previous - question.diff?.index?.current || 0

  const mapValues = {
    label: 'Label'
  }

  return (
    <>
      <button
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={itemStyles}
        onClick={() => setEditable(question)}
      >
        <span
          {...provided.dragHandleProps}
          style={{
            display: 'inline-block',
            position: 'absolute',
            top: 'calc(50%)',
            transform: 'translateY(-50%)',
            left: '-25px',
            color: '#D2CECE'
          }}
        >
          <MdDragIndicator
            width={20}
          />
        </span>
        <div
          className={cx(styles.issueDraggableContainer, styles[question.type], {
            [styles.active]: !question.hidden
          })}
        >
          {question.label}
          <div className={styles.rightContainer}>
            <div
              style={{
                alignSelf: 'center',
                marginRight: '15px'
              }}
            >
              {Object.keys(question?.diff || {})?.map(
                val =>
                  mapValues[val] && (
                    <span
                      key={val}
                      className={styles.diffTag}
                    >
                      {mapValues[val]}
                    </span>
                  )
              )}
            </div>
            <div
              style={{
                marginRight: '15px',
                alignSelf: 'center',
                width: '20px',
                color: '#9a9797'
              }}
            >
              {sing(positionDiff)}
            </div>
            <div className={styles.domain}>{domains?.[question?.domain] || ''}</div>
            {actionIcon(question)}
          </div>
        </div>
      </button>
      <Divider />
      {editableQuestion?.id === question.id && (
        <div className={styles.editQuestionForm}>
          <StaticItemEdit
            setModal={setModal}
            applyChanges={applyChanges}
            item={editableQuestion}
            setEditableQuestion={setEditableQuestion}
            items={items}
          />
        </div>
      )}
    </>
  )
}

export default OtherItem
